import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { editRulesByIdFailed, editRulesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import RulesDTO from '../../../dto/RulesDTO';

export default function* editRulesById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/rules/${action.payload.id}`;
    const pool = new RulesDTO(action.payload).getData();
    const response = yield makeRequest(url, pool, action, 'PUT', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(editRulesByIdSuccessful());
      yield call(resolveActionPromise(action, data.rule));
    } else {
      const data = yield getBodyJson(response);
      yield put(editRulesByIdFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(editRulesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
